import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { TrackingLink } from 'lib/app/tracking-link';
import { CdnImagePath } from 'lib/cdn-image-path';

import { onClickWhatsNewDateCta } from 'containers/events';

import PageSectionCta from 'components/page/sections/page-section-cta';
import { P1 } from 'components/typography';

export const VideoChatBlockOneContainer: FunctionComponent = () => {
  const props = {
    imageSrc: `${CdnImagePath}/landing/assets/photos/features/video-chat/video-chat-block-1.jpg`,
    imageAlt: '',
    imageObjectPosition: '65% 10%',
    title: features.audioCalls.lxAudioCallsOneBlockTitle,
    text: features.audioCalls.lxAudioCallsOneBlockBodyText,
    actionText: features.audioCalls.lxFeaturesDownloadBumbleCta,
    actionUrl: TrackingLink.APPSFLYER_LINK,
  };

  return (
    <PageSectionCta
      title={props.title}
      text={<P1 html={props.text} />}
      action={{
        text: props.actionText,
        href: props.actionUrl,
        onClick: onClickWhatsNewDateCta,
      }}
      image={{
        src: props.imageSrc,
        objectPosition: props.imageObjectPosition,
      }}
      color="orange"
    />
  );
};
